import { Center, Loader, Modal } from "@mantine/core"

import { InlineBanner } from "~/components/InlineBanner"
import { useFindIngestionErrorLogs } from "~/gen/api"
import { ErrorPreview } from "~/pages/Admin/Ingestion/ProductImport/components/ErrorPreview"

type Props = {
  ingestionId: string
  opened: boolean
  onClose: () => void
}

export function ErrorPreviewModal({ ingestionId, opened, onClose }: Props) {
  const {
    data: errorLogsResponse,
    isPending: isLoading,
    error,
  } = useFindIngestionErrorLogs(ingestionId, {
    query: {
      enabled: opened,
    },
  })

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={errorLogsResponse?.data.title}
      size="90%"
    >
      {isLoading ? (
        <Center h={200}>
          <Loader size="lg" />
        </Center>
      ) : null}

      {error ? (
        <InlineBanner
          type="error"
          message="An error occurred while retrieving errors"
          closable={false}
        />
      ) : null}

      {!isLoading && !error && errorLogsResponse?.data ? (
        <ErrorPreview errorLogs={errorLogsResponse.data} />
      ) : null}
    </Modal>
  )
}
